import React from "react";
import { Link } from "react-router-dom";

function Splash() {
	return (
		<div className="container">
			<div className="row">
				<div className="col-12">
					<img
						style={{
							marginTop: 200,
							width: "70%",
							marginBottom: 200,
							display: "block",
							marginLeft: "auto",
							marginRight: "auto",
						}}
						src={require("../../assets/logo.png")}
					/>
				</div>
			</div>
			<div className="row">
				<div className="col-12">
					<Link
						to="/presentation"
						className="btn btn-block btn-custom btn-lg bg-gradient"
					>
						Começar
					</Link>
				</div>
			</div>
		</div>
	);
}

export default Splash;
